<div
  class="ui label warning-label"
  style="
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-direction: column;
  "
  *ngIf="message"
>
  <div>{{ message }}</div>
  <button
    *ngIf="redirect_url"
    style="margin-top: 15px"
    class="ui primary button"
  >
    <a (click)="redirectToExternalUrl()" style="color: white">
      Go back to {{ applicationType }} application
    </a>
  </button>
</div>

<div
  class="ui success message"
  *ngIf="affiliateTypeName == 'Proprietor' || affiliateTypeName == 'proprietor'"
>
  <p>Please Note:</p>
  <span>
    Details of Proprietors to be added/updated must be listed in CAC Company
    Status Report. Contact CAC if you do not have your CAC Company Status
    Report</span
  >
</div>
<div
  class="ui success message"
  *ngIf="
    affiliateTypeId === 'shareholder_type' &&
    (companyTypeId === 'business_name_actual' ||
      companyTypeId === 'business_name')
  "
>
  <p>Please Note:</p>
  <span>
    • Details of Shareholder (the Proprietor) to be added/updated must be listed
    in CAC Company Status Report.</span
  >
</div>
<div
  class="ui success message"
  *ngIf="
    affiliateTypeId === 'shareholder_type' &&
    companyTypeId !== 'business_name_actual' &&
    companyTypeId !== 'business_name'
  "
>
  <p>Please Note:</p>
  <span>
    • Details of Shareholder to be added/updated must be listed in CAC Company
    Status Report.</span
  >
  <span>
    • Formula for Percentage of Shareholding is Number of Shares Allocated/Total
    Share Capital * 100</span
  >
</div>
<div
  class="ui success message"
  *ngIf="affiliateTypeName === 'Company Secretary'"
>
  <p>Please Note:</p>
  <span>
    • Details of Company Secretary to be added/updated must be listed in CAC
    Company Status Report.</span
  >
  <span>
    • If you do not have a Company Secretary, complete Profile using details of
    Director listed in CAC Status Report and under ‘Upload CAC Status Report’,
    upload a signed Letter from your Company to the Commission stating your
    Company does not have a Company Secretary.</span
  >
  <span>
    • If you want to add/update details of Company Secretary not listed in CAC
    Company Status Report, complete Profile using details of this Company
    Secretary and under ‘Upload CAC Status Report’, upload a Signed Letter from
    your Company to the Commission with details of this Company Secretary
    listed.</span
  >
</div>
<div class="ui success message" *ngIf="affiliateTypeId === 'director_type'">
  <p>Please Note:</p>
  <span>
    Details of Director to be added/updated must be listed in CAC Company Status
    Report. Contact CAC if you do not have your CAC Company Status Report</span
  >
</div>
<div class="ui vertical basic segment" *ngIf="success || error">
  <esl-message-toast [(message)]="error"></esl-message-toast>
  <esl-message-toast
    [(message)]="success"
    [messageType]="'success'"
  ></esl-message-toast>
</div>
<div class="linked_not" *ngIf="updateMode">UPDATE MODE</div>
<div class="heading_container">
  <div class="title">
    <h2 (click)="consoleThings()">{{ affiliateTypeName | plural | titlecase }}</h2>
  </div>
  <div
    class="updates_button"
    style="gap: 16px; align-items: center; display: flex"
  >
    <button
      style="background-color: #3f4395; height: 36px; color: #ffffff"
      class="ui button"
      *ngIf="!updateMode"
      (click)="goToUpdate()"
      [disabled]="pendingArr?.length > 0"
    >
      Make Updates
    </button>
    <div
      *ngIf="updateMode"
      style="gap: 16px; align-items: center; display: flex"
    >
      <button
        *ngIf="affiliateTypeId === 'shareholder_type'"
        style="
          background-color: #ffffff;
          height: 36px;
          color: #3f4395;
          border: 1px solid #3f4395;
        "
        class="ui button"
      >
        <sui-checkbox
          class="toggle two_factor_setting_users_org new"
          [(ngModel)]="usePercentage"
          (ngModelChange)="onUsePercentageChange($event)"
        >
          <p style="color: #3f4395; margin-top: -5px; font-weight: 500">
            Use Percentage
          </p>
        </sui-checkbox>
      </button>
      <div
        *ngIf="
          affiliateTypeId === 'shareholder_type' &&
          companyTypeId !== 'business_name_actual' &&
          companyTypeId !== 'business_name'
        "
        suiDropdown
        style="
          padding: 11px 16px;
          border-radius: 8px;
          border: 1px solid #3f4395;
          height: 36px;
          background-color: #ffffff;
          position: relative;
        "
      >
        <button
          style="
            color: #3f4395;
            border: none;
            gap: 12px;
            display: flex;
            align-items: center;
            margin-top: -1px;
            cursor: pointer;
            background: none;
          "
        >
          Add Individual/Company
          <svg
            width="10"
            height="6"
            viewBox="0 0 10 6"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M1.20711 0.5C0.761654 0.5 0.538571 1.03857 0.853553 1.35355L4.64645 5.14645C4.84171 5.34171 5.15829 5.34171 5.35355 5.14645L9.14645 1.35355C9.46143 1.03857 9.23835 0.5 8.79289 0.5H1.20711Z"
              fill="#3F4395"
            />
          </svg>
        </button>
        <div
          class="menu"
          style="
            height: 80px;
            margin-top: 10px;
            position: absolute;
            width: 208px;
            right: 0px;
            z-index: 10000;
          "
          suiDropdownMenu
          appPadding
          paddingX="3"
        >
          <div
            class="item"
            style="
              font-family: 'Roboto';
              font-size: 12px;
              font-weight: 400;
              line-height: 14.06px;
              text-align: left;
              color: #505050;
              display: flex;
              align-items: center;
              justify-content: flex-start;
              height: 40px;
              cursor: pointer;
              background: none;
            "
            (click)="addIndividual()"
          >
            Add Individual
          </div>
          <a
            class="item"
            style="
              font-family: 'Roboto';
              font-size: 12px;
              font-weight: 400;
              line-height: 14.06px;
              text-align: left;
              color: #505050;
              display: flex;
              align-items: center;
              justify-content: flex-start;
              height: 40px;
              cursor: pointer;
            "
            (click)="addCompany()"
            >Add Company</a
          >
        </div>
      </div>

      <button
        *ngIf="
          affiliateTypeId !== 'shareholder_type' ||
          (affiliateTypeId === 'shareholder_type' &&
            (companyTypeId === 'business_name_actual' ||
              companyTypeId === 'business_name'))
        "
        style="
          background-color: #ffffff;
          height: 36px;
          color: #3f4395;
          border: 1px solid #3f4395;
          background: none;
        "
        class="ui button"
        (click)="addIndividual()"
      >
        Add Individual
      </button>
      <div
        class="ui mini basic primary dropdown button"
        style="height: 35px; padding-top: 12px"
        suiDropdown
      >
        <div
          class="text"
          style="color: #3f4395; font-weight: 600; font-size: 14px"
        >
          Submit
        </div>
        <i class="dropdown icon"></i>
        <div class="left menu" suiDropdownMenu>
          <div
            class="item"
            (click)="isSubmitDisabled() ? null : confirmAndSubmit('save')"
            [ngStyle]="{
              opacity: isSubmitDisabled() ? '0.5' : '1',
              cursor: isSubmitDisabled() ? 'not-allowed' : 'pointer'
            }"
          >
            Submit
          </div>
          <div
            class="item"
            (click)="
              !checkIfStructureChanged() ? confirmAndSubmit('later') : null
            "
            [ngStyle]="{
              opacity: !checkIfStructureChanged() ? '1' : '0.5',
              cursor: !checkIfStructureChanged() ? 'pointer' : 'not-allowed'
            }"
          >
            Save and Continue Later
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div
  class="share_capital"
  *ngIf="!usePercentage && updateMode && affiliateTypeId === 'shareholder_type'"
>
  <label for="">Total Share Capital <span>*</span> :</label>
  <div class="input_div">{{ shareholdingAmount | number: "1.0-0" }}</div>
  <img
    src="assets/icons/editIcon.svg"
    style="cursor: pointer"
    (click)="editShares()"
    alt=""
  />
</div>
<div
  class="ui vertical basic segment"
  [ngClass]="{ loading: pendingArr?.length }"
  appMargin="0"
  appPadding="0"
>
  <div class="tabs" *ngIf="!updateMode">
    <sui-tabset>
      <div
        class="ui secondary pointing menu"
        style="border-bottom: 1px solid #dadada"
      >
        <a
          class="item large__font-size"
          routerLinkActive="active"
          routerLink="/contractor/company/ownership-structure/verified"
          (click)="getPage(1)"
          [queryParams]="{
            typeId: affiliateTypeId,
            typeName: affiliateTypeName
          }"
          >Verified
          <div class="ui gray label mini circular large__caption">
            {{ totalItems }}
          </div></a
        >
        <a
          class="item large__font-size"
          routerLinkActive="active"
          [routerLink]="['/contractor/company/ownership-structure/pending']"
          (click)="getPageHistory(1)"
          [queryParams]="{
            typeId: affiliateTypeId,
            typeName: affiliateTypeName
          }"
          >Pending Verification
          <div class="ui gray label mini circular large__caption">
            {{ pendingStructure }}
          </div>
        </a>
        <a
          class="item large__font-size"
          routerLinkActive="active"
          (click)="getPageHistory(1)"
          [routerLink]="'/contractor/company/ownership-structure/history'"
          [queryParams]="{
            typeId: affiliateTypeId,
            typeName: affiliateTypeName
          }"
          >History
          <div class="ui gray label mini circular large__caption">
            {{ historyTotalItems }}
          </div></a
        >
      </div>
      <div class="ui basic segment" style="margin: 0; border: 0; padding: 0">
        <!-- <router-outlet></router-outlet> -->
        <app-company-verified-structure
          [companyDirectors]="companyDirectors"
          [allStatus]="allStatus"
          [typeStructure]="typeStructure"
          [personnelStructureKeys]="personnelStructureKeys"
          [verifiedStrcuture]="verifiedStrcuture"
          [verifiedHistory]="verifiedHistory"
          [verifiedArray]="verifiedArray"
          *ngIf="isVerifiedRoute()"
        ></app-company-verified-structure>
        <app-company-pending-structure
          [allStatus]="allStatus"
          [personnelStructureKeys]="personnelStructureKeys"
          [typeStructure]="typeStructure"
          [pendingArray]="pendingArray"
          [pendingHistory]="pendingHistory"
          [pendingStrcuture]="pendingStrcuture"
          [pendingDocuments]="pendingDocuments"
          [verifiedArray]="verifiedArray"
          (deleteRequest)="deleteRequest($event)"
          *ngIf="isPendingRoute()"
        ></app-company-pending-structure>
        <app-company-history-structure
          [allStatus]="allStatus"
          [personnelStructureKeys]="personnelStructureKeys"
          [typeStructure]="typeStructure"
          [history]="history"
          [totalItems]="historyTotalItems"
          [currentPage]="currentPage"
          [rows]="rows"
          *ngIf="isHistoryRoute()"
        ></app-company-history-structure>
      </div>
    </sui-tabset>
  </div>
  <div class="tabs" *ngIf="updateMode">
    <div class="ui basic segment" style="margin: 0; border: 0; padding: 0">
      <!-- <router-outlet></router-outlet> -->
      <app-company-update-mode
        [companyDirectors]="companyDirectors"
        [countries]="countries"
        [documentsValid]="documentsValid"
        [existing]="savedChangeRequestExisting"
        [documentss]="documentss"
        [uploads]="uploads"
        [savedPreviousStructure]="savedPreviousStructure"
        [typeStructure]="typeStructure"
        [initialDirectorsStructure]="initialDirectorsStructure"
        [usePercentage]="usePercentage"
        [shareholdingAmount]="shareholdingAmount"
        [uploadedDocuments]="uploadedDocuments"
        [allLinkedDocuments]="allLinkedDocuments"
        (updateDirector)="updateDirector($event)"
        (LinkDocument)="LinkDocument($event)"
        (startAfresh)="deleteRequestConfirmatione($event)"
      ></app-company-update-mode>
    </div>
  </div>
</div>
